import { RestorePasswordService } from './restore-password.service';

export * from './restore-password.service';

export const RESTORE_PASSWORD_SERVICES = [
  RestorePasswordService,
];
